import * as React from 'react'
import { ITripHistoryObject } from '../../types'
import TripHistoryDetailSection from './TripHistoryDetailSection'

interface ITripHistoryVehicleDetailsProps {
  trip: ITripHistoryObject
}

const TripHistoryVehicleDetails = (props: ITripHistoryVehicleDetailsProps) => {
  const trip = props.trip
  if (!trip.vehicle) {
    return null
  }
  return (
    <TripHistoryDetailSection title='Vehicle'>
      <div className='h6 mb02'>{trip.vehicle.make + ' ' + trip.vehicle.model}</div>
      <div className='h6 font-grey mb2'>Product name by {trip.provider}</div>
      <div className='flex h6 mb02 font-grey'>
        <div className='col-6'>Fleet ID</div>
        <div className='col-6 right-align'>{trip.vehicle.fleedId}</div>
      </div>
      <div className='flex h6 mb02 font-grey'>
        <div className='col-6'>License plate</div>
        <div className='col-6 right-align'>{trip.vehicle.licensePlate}</div>
      </div>
      <div className='flex h6 mb02 font-grey'>
        <div className='col-6'>Year</div>
        <div className='col-6 right-align'>{trip.vehicle.year}</div>
      </div>
      <div className='flex h6 mb02 font-grey'>
        <div className='col-6'>Capacity</div>
        <div className='col-6 right-align'>{trip.vehicle.capacity}</div>
      </div>
      <hr />
    </TripHistoryDetailSection>
  )
}

export default TripHistoryVehicleDetails



// WEBPACK FOOTER //
// ./src/components/trips/TripHistoryVehicleDetails.tsx